interface AlertCardProps {
  alert: string;
  isSelected: boolean;
  onToggle: (alert: string, isSelected: boolean) => void;
  children?: React.ReactNode;
}

function AlertCard({ alert, isSelected, onToggle, children }: AlertCardProps): JSX.Element {
  return (
    <label className="App-alert-card">
      <input
        type="checkbox"
        checked={isSelected}
        onChange={(e) => onToggle(alert, e.target.checked)}
        className="App-alert-checkbox"
      />
      <div className="App-alert-content">
        <div className="App-alert-icon">⚠️</div>
        <div className="App-alert-text-container">
          {children || <span className="App-alert-text">{alert}</span>}
        </div>
      </div>
    </label>
  );
}

export default AlertCard;

